function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.3 12.6l-.1-.1C1.8 9.3-.2 5.7 0 1.6 0 1.6.1.3 1.3.1c2.4-.4 3.3.8 4.1 1.8l.6.6C6.5 1.9 8.2 0 9.2 0c1 .1 1.6.5 1.9 1.5.2.8.2 1.7.1 2.5v.1c-.1 2.5-3.1 6.2-4.7 8.2l-.2.3zM2.4.5c-.3 0-.6 0-.9.1C.5.8.4 1.8.4 1.8.3 5.6 2.1 8.9 6.2 12.1l.1-.1c1.5-1.9 4.3-5.4 4.4-7.8v-.1c0-.7.1-1.6-.1-2.3C10.4 1 9.9.6 9 .6 8.1.6 6.2 2.8 6.1 3l-.1.2-.1-.3.1-.1-.1.1c-.3-.2-.5-.5-.7-.7C4.6 1.4 3.9.5 2.4.5z",
  fill: "#af9c7e"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.5.7c-.3 0-.5 0-.8.1C.7 1 .7 2 .7 2c-.2 3.6 1.6 6.8 5.5 9.8l.1-.1c1.4-1.8 4.1-5.2 4.3-7.5v-.1c0-.7.1-1.6-.1-2.2C10.3 1.1 9.8.8 9 .7c-1 0-2.8 2.2-2.9 2.4l-.1.2-.1-.2V3v.1c-.3-.2-.5-.5-.7-.8C4.7 1.6 4 .7 2.5.7z",
  fill: "#cde5b4"
});

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 11.2 12.6",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.25ae27ec.svg";
export { ForwardRef as ReactComponent };